import React from "react";

const GithubIcon = props => (
  <svg
    width="121px"
    height="119px"
    viewBox="0 0 121 119"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <title>Fill 5</title>
    <desc>Created with Sketch.</desc>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="GitHub-Mark"
        transform="translate(-290.000000, -6.000000)"
        fill={props.fill}
      >
        <path
          d="M350.609,6.445 C317.262,6.445 290.221,33.481 290.221,66.833 C290.221,93.514 307.524,116.15 331.518,124.135 C334.536,124.694 335.644,122.825 335.644,121.23 C335.644,119.79 335.588,115.033 335.562,109.987 C318.762,113.64 315.217,102.862 315.217,102.862 C312.47,95.882 308.512,94.026 308.512,94.026 C303.033,90.278 308.925,90.355 308.925,90.355 C314.989,90.781 318.182,96.578 318.182,96.578 C323.568,105.81 332.309,103.141 335.755,101.598 C336.297,97.695 337.862,95.031 339.589,93.523 C326.176,91.996 312.076,86.818 312.076,63.679 C312.076,57.086 314.435,51.699 318.298,47.47 C317.671,45.949 315.604,39.807 318.883,31.489 C318.883,31.489 323.954,29.866 335.494,37.679 C340.311,36.341 345.477,35.67 350.609,35.647 C355.741,35.67 360.911,36.341 365.737,37.679 C377.263,29.866 382.327,31.489 382.327,31.489 C385.614,39.807 383.546,45.949 382.919,47.47 C386.791,51.699 389.134,57.086 389.134,63.679 C389.134,86.873 375.007,91.98 361.56,93.475 C363.726,95.349 365.656,99.024 365.656,104.658 C365.656,112.738 365.586,119.241 365.586,121.23 C365.586,122.837 366.673,124.72 369.734,124.127 C393.715,116.133 410.996,93.505 410.996,66.833 C410.996,33.481 383.959,6.445 350.609,6.445"
          id="Fill-5"
        ></path>
      </g>
    </g>
  </svg>
);

export default GithubIcon;
